import { track } from "@amplitude/analytics-browser";
import { formatDate } from "@angular/common";
import { Input, Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { EntityRef, Setting, SettingReview, SettingsService, SettingsUpdateRequest } from "src/app/core/settings/settings.service";

@Component({
  selector: 'request-view-modal',
  templateUrl: './request-view-modal.component.html',
  styleUrls: ['./request-view-modal.component.scss']
})

export class SettingsRequestViewModalComponent implements OnInit {
  @Input() requestId!: string;

  loading = true;
  settingsUpdateRequest: SettingsUpdateRequest | undefined;
  reviews: SettingReview[] = [];
  requestDate = '';
  reviewDate = '';
  settings: Setting[] = [];
  entitiesList: EntityRef[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private bulkSettingRequestService: SettingsService,
  ) { }

  async getData(): Promise<void> {
    try {
      this.settingsUpdateRequest = await this.bulkSettingRequestService.getSettingsUpdateRequest(this.requestId);

      this.entitiesList = this.settingsUpdateRequest.entities;
      this.settings = this.settingsUpdateRequest.settings;
      this.reviews = this.settingsUpdateRequest.reviews;
      this.requestDate = formatDate(this.settingsUpdateRequest.requestDate, 'short', 'en-US');
      if (this.reviews?.length > 0)
        this.reviewDate = formatDate(this.reviews[0].reviewDate, 'short', 'en-US');
    } catch (error) {
      this.toastr.error('Failure retrieving data.');
    }
    finally {
      this.loading = false;
    }
  }

  ngOnInit(): void {
    track('Control Center Settings Request View modal Loaded');
    this.getData();
  }

  cancel() {
    this.activeModal.close(false);
  }
}
